import { createSlice } from "@reduxjs/toolkit";
import { abandonedGift as initialState } from "../initialState";

const getAbandonedGiftInitialState = () => {
    const { storedAbandonedGiftData = {} } = initialState;
    const abandonedGiftsInitialState = {
        ...initialState,
        storedAbandonedGiftData,
        acceptedReminder: false,
        acceptedEmailReminders: false,
        emailForReminders: "",
        closedElementFromApp: false,
        First_Name: "",
        Last_Name: "",
        Email: "",
        otherAmountData: {},
        reminderData: {},
        // -------------------------------------------------------------------------
        // TODO: Use Enum when available
        // -------------------------------------------------------------------------
        source: 0,
        hasBeenPromptedToReturnToGift: false,
        hasScheduledEmailReminders: false,
    };
    return abandonedGiftsInitialState;
};

export const abandonedGiftInitialState = getAbandonedGiftInitialState();

const slice = createSlice({
    name: "abandonedGift",
    initialState: abandonedGiftInitialState,
    reducers: {
        setAbandonedGiftReminderData: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        setAbandonedGiftOtherAmountData: (state, action) => ({
            ...state,
            otherAmountData: {
                ...action.payload,
            },
        }),
        setAbandonedGiftDataFirstName: (state, action) => ({
            ...state,
            First_Name: action.payload,
        }),
        setAbandonedGiftDataLastName: (state, action) => ({
            ...state,
            Last_Name: action.payload,
        }),
        setAbandonedGiftDataEmail: (state, action) => ({
            ...state,
            Email: action.payload,
        }),
        setAbandonedGiftDataClosedElementFromApp: (state, action) => ({
            ...state,
            closedElementFromApp: action.payload,
        }),
        setAcceptEmailRemindersData: (state, action) => {
            const { acceptedEmailReminders = false, emailForReminders = "" } =
                action.payload;
            return {
                ...state,
                acceptedEmailReminders,
                emailForReminders,
            };
        },
        setHasScheduledEmailReminders: (state, action) => {
            state.hasScheduledEmailReminders = action.payload;
        },
        setAbandonedGiftSource: (state, action) => {
            state.source = action.payload;
        },
        setHasBeenPromptedToReturnToGift: (state, action) => {
            state.hasBeenPromptedToReturnToGift = action.payload;
        },
    },
});

export const {
    setAbandonedGiftDataClosedElementFromApp,
    setAbandonedGiftDataFirstName,
    setAbandonedGiftDataLastName,
    setAbandonedGiftDataEmail,
    setAbandonedGiftOtherAmountData,
    setAbandonedGiftReminderData,
    setAbandonedGiftSource,
    setAcceptEmailRemindersData,
    setHasBeenPromptedToReturnToGift,
    setHasScheduledEmailReminders,
} = slice.actions;

export const selectAbandonedGiftData = (state) => state.abandonedGift;

export const selectAbandonedGiftOtherAmountData = (state) =>
    state.abandonedGift.otherAmountData;

export const selectAbandonedGiftToken = (state) =>
    state.abandonedGift.qgiv_abandoned_gift;

export const selectAbandonedGiftClosedElementFromApp = (state) =>
    state?.abandonedGift?.closedElementFromApp;

export const selectAcceptedEmailReminders = (state) =>
    state.abandonedGift.acceptedEmailReminders;

export const selectEmailForReminders = (state) =>
    state.abandonedGift.emailForReminders;

export const selectAbandonedGiftsStoredData = (state) =>
    state.abandonedGift.storedAbandonedGiftData;

export const selectAbandonedGiftSource = (state) => state.abandonedGift.source;

export default slice.reducer;
